import { ParsedCustomFieldConfig } from '@work4all/data/lib/custom-fields';

import { CustomField } from '@work4all/models/lib/Classes/CustomField.entity';
import { IndividualFieldControlType } from '@work4all/models/lib/Enums/IndividualFieldControlType.enum';

import { decodeCustomFieldName } from './custom-field-name';
import { EncodedCustomFieldName } from './types';

type InputWithMappedCustomFields<T> = Omit<T, '_customFields'> & {
  customFieldList?: CustomField[];
};

export function prepareInputWithCustomFields<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  T extends { _customFields?: Record<string, any> }
>(
  input: T,
  definitions: ParsedCustomFieldConfig[]
): InputWithMappedCustomFields<T> {
  const { _customFields: customFields, ...clone } = input;

  const result: InputWithMappedCustomFields<T> = clone;

  if (customFields) {
    const customFieldList = serializeCustomFieldValues(
      customFields,
      definitions
    );
    result.customFieldList = customFieldList;
  }

  return result;
}

function serializeCustomFieldValues(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fieldValues: Record<EncodedCustomFieldName, any>,
  definitions: ParsedCustomFieldConfig[]
): CustomField[] {
  const customFieldList: CustomField[] = Object.entries(fieldValues)
    .map(([fieldKey, value]) => {
      const key = decodeCustomFieldName(fieldKey as EncodedCustomFieldName);
      const definition = definitions.find(
        (definition) => definition.id === key
      );
      if (value == null) {
        // Date can be null
        if (definition.fieldType !== IndividualFieldControlType.DATE_TYPE)
          return null;
      }

      return {
        // Remove the "f" prefix from the field key.
        key,
        value: JSON.stringify(value),
      };
    })
    .filter(Boolean);

  return customFieldList;
}
